import InterestCalculatedOnBalanceType from "@/models/Products/InterestCalculatedOnBalanceType";
import InterestDaysInYear from "@/models/Products/InterestDaysInYear";
import InterestNonWorkingDays from "@/models/Shared/NonWorkingDays";
import PostingScheduleType from "@/models/Shared/PostingScheduleType";
import InterestRateType from "@/models/Products/InterestRateType";
import PeriodType from "@/models/Shared/PeriodType";
import Amount from "@/models/Shared/Amount";
import DayOfWeek from "@/models/Shared/DayOfWeek";
import Month from "@/models/Shared/Month";
import BaseProductSettings from "@/models/Products/ProductSettings/BaseProductSettings";
import EntityIdentifier from "@/models/Shared/EntityIdentifier";

export default class SecondaryWalletTypeDepositInterestSettings extends BaseProductSettings {
    overridden: boolean = false;
    enabled: boolean = false;
    interestBearingThreshold: Amount = new Amount();
    rateType: InterestRateType = InterestRateType.Fixed;
    rateValue: number = 0;
    cumulativeRateValue: number = undefined;
    rateSourceId: string;
    rateSourceIdentifier: EntityIdentifier;
    accruedPeriodType: PeriodType = PeriodType.Day;
    accruedPeriodValue: number = 1;
    accruedPeriodOnDayOfWeek: DayOfWeek = undefined;
    accruedPeriodOnDayOfMonth: number = undefined;
    accruedPeriodOnMonth: Month = undefined;
    calculatedOnBalanceType: InterestCalculatedOnBalanceType = InterestCalculatedOnBalanceType.AverageDailyBalance;
    postingScheduleType: PostingScheduleType = PostingScheduleType.FixedSchedule;
    postedPeriodType: PeriodType = PeriodType.Day;
    postedPeriodValue: number = 1;
    postedPeriodOnDayOfWeek: DayOfWeek = undefined;
    postedPeriodOnDayOfMonth: number = undefined;
    postedPeriodOnMonth: Month = undefined;
    daysInYearType: InterestDaysInYear = InterestDaysInYear.Actual365;
    nonWorkingDaysType: InterestNonWorkingDays = InterestNonWorkingDays.NextWorkingDay;
}